import { CalendlyService } from './../../services/calendly/calendly.service';
import { Component, OnInit } from '@angular/core';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { MeetingFiltersComponent } from "./meeting-filters/meeting-filters.component";
import { ButtonModule } from 'primeng/button';
import { ScheduledCallsForMentorRequest } from '../../models/calendly/scheduledCallsForMentorRequest';
import { ScheduledCallsForMentorResponse } from '../../models/calendly/scheduledCallsForMentorResponse';
import { MeetingState } from '../../models/enums/enums';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { ScheduleMentorCallMeetingnotesService } from '../../services/schedule-mentor-call-meetingnotes/schedule-mentor-call-meetingnotes.service';
import { ScheduledMeetingNotesResponse } from '../../models/schedule-mentor-call-meetingnotes/scheduledMeetingNotesResponse';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-scheduled-meetings',
  standalone: true,
  imports: [TableModule, MeetingFiltersComponent, ButtonModule, CommonModule, RouterModule, DialogModule, FormsModule],
  templateUrl: './scheduled-meetings.component.html',
  styleUrl: './scheduled-meetings.component.scss'
})
export class ScheduledMeetingsComponent implements OnInit {
  isSearching: boolean = false;
  visible: boolean = false;
  meetings: ScheduledCallsForMentorResponse[] = [];
  meetingNote: ScheduledMeetingNotesResponse | undefined;
  meetingNoteText: string = '';
  currentMeetingId: number | undefined;
  total: number = 0;
  first: number = 0;
  rowSize: number = 10;
  request!: ScheduledCallsForMentorRequest;
  constructor(private calendlyService: CalendlyService, private meetingnotesService: ScheduleMentorCallMeetingnotesService,
    private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.request = {
      startDate: null,
      endDate: null,
      meetingStatus: MeetingState.Active,
      pageNumber: 1,
      pageSize: this.rowSize
    };
    this.search();
  }

  getMeetingNotes(meetingId: number){
    this.visible = true;
    this.currentMeetingId = meetingId;
    this.meetingNote = undefined;
    this.meetingNoteText = '';
    this.meetingnotesService.getScheduledMeetingNotes(meetingId).subscribe({
      next: (response) => {
        if(response){
          this.meetingNote = response;
          this.meetingNoteText = response.meetingNotes || '';
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Meeting notes not found!' });
      }
    })
  }

  deleteMeetingNotes(meetingId: number){
    this.meetingnotesService.deleteScheduledMeetingEndPoint(meetingId).subscribe({
      next: (response) =>{
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Meeting notes deleted successfully!' });
        this.meetingNote = undefined;
        this.meetings.find(m => m.scheduledMeetingId === meetingId)!.meetingNotes = '';
        this.meetingNoteText = '';
        this.currentMeetingId = undefined;
        this.visible = false;
      },
      error: (err) => {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to delete meeting notes!'});
        console.error(err);
      }
    })
  }

  addMeetingNotes(){

    this.meetingnotesService.updateScheduledMeetingNotes({
      scheduledMeetingId: this.currentMeetingId!,
      meetingNotes: this.meetingNoteText
    }).subscribe({
      next: (response) => {
        this.meetingNote = response;
        this.meetings.find(m => m.scheduledMeetingId === this.currentMeetingId)!.meetingNotes = this.meetingNoteText;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Meeting notes updated successfully!' });
        this.visible = false;
      },
      error: (err) => {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Failed to update meeting notes!'});
        console.error(err);
      }
    })
  }

  searchMeetings($event: ScheduledCallsForMentorRequest) {
    this.request = $event;
    this.search();
  }

  search() {
    this.isSearching = true;
    this.calendlyService.getScheduledMeeting(this.request).subscribe({
      next: (response) => {
        this.meetings = response.result;
        this.total = response.total;
        this.isSearching = false;
      },
      error: (error) => {
        console.error(error);
        this.isSearching = false;
      }
    });
  }

  onLazyLoad($event: TableLazyLoadEvent) {
    const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
    this.first = $event.first ?? 0;
    this.rowSize = $event.rows ?? this.rowSize;
    this.request = { ...this.request, pageNumber: pageNumber, pageSize: this.rowSize };
    this.search();
  }

  getLocalDate(dateArg: string) {
    var date = new Date(dateArg);
    // Format the local date as "March 06, 2025"
    const localDate = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    }).replace(/(\d{2}) (\w+) (\d{4})/, '$2 $1, $3'); // Ensure "March 06, 2025"

    return localDate;
  }
  getLocalTime(dateArg: string) {
    var date = new Date(dateArg);
    // Format the local time as "9:30 AM"
    const localTime = date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).toUpperCase(); // Capitalize AM/PM

    return localTime;
  }

  openCalendlyURI(arg0: any) {
    window.open(arg0, '_blank');
  }
}
